import AuthSessionStatus from '@components/AuthSessionStatus'
import { AtButton, AtButtonVariant, MlFormField } from '@curran-catalog/curran-atomic-library'
import { FormEvent, useState } from 'react'
import { ForgotPasswordValidationErrors, useAuth } from '../../hooks/use-auth'

export const TmForgotPassword = () => {
  const { forgotPassword } = useAuth({ middleware: 'guest', redirectIfAuthenticated: '/' })

  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState<ForgotPasswordValidationErrors>({})
  const [status, setStatus] = useState<string | null>(null)

  const submitForm = (event: FormEvent) => {
    event.preventDefault()

    forgotPassword({ email, setErrors, setStatus })
  }

  return (
    <div className="md:max-w-md mx-auto py-12">
      <div className="mb-4">Forgot your password? Enter your email to reset it.</div>

      {/* Session Status */}
      <AuthSessionStatus className="mb-4" status={status} />

      <form onSubmit={submitForm}>
        {/* Email Address */}
        <MlFormField
          label="Email"
          name="email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          autoFocus
          error={Object.prototype.hasOwnProperty.call(errors, 'email')}
          errorMessage={errors.email}
          autoComplete="email"
        />
        <div className="flex items-center justify-end mt-4">
          <AtButton
            type="submit"
            className="w-full"
            label="Email Password Reset Link"
            variant={AtButtonVariant.PRIMARY}
            disabled={status !== null}
          />
        </div>
      </form>
    </div>
  )
}
